/**
 * app-config.const.ts
 * Centralised numeric and timing constants used across the application.
 * Keep all magic numbers here — never inline them in component or service logic.
 */

// ---------------------------------------------------------------------------
// Widget
// ---------------------------------------------------------------------------

/** Delay after ROUND-END event before restarting the countdown timer (ms) */
export const ROUND_END_REFRESH_DELAY_MS = 2_000;

/** Interval at which the countdown timer ticks (ms) */
export const WIDGET_REFRESH_RATE_MS = 500;

/** Delay before showing the NoWallet modal to let the current modal close first (ms) */
export const NO_WALLET_MODAL_DELAY_MS = 500;

// ---------------------------------------------------------------------------
// Header
// ---------------------------------------------------------------------------

/** Scroll threshold (px from top) at which the header gains the 'scrolled' class */
export const HEADER_SCROLL_THRESHOLD_PX = 50;

/** Delay before highlighting the active nav link after route change (ms) */
export const HEADER_NAV_HIGHLIGHT_DELAY_MS = 1_000;

/** Delay before triggering wallet connection after showing buy widget (ms) */
export const CONNECT_WALLET_DELAY_MS = 1_000;

/** Duration of the mobile menu closing animation — menu hides after this (ms) */
export const MENU_CLOSE_ANIMATION_MS = 600;

/** Duration of the mobile menu opening animation — open class applied after this (ms) */
export const MENU_OPEN_ANIMATION_MS = 300;

// ---------------------------------------------------------------------------
// Language / Consent
// ---------------------------------------------------------------------------

/** Delay before scrolling to a URL fragment to allow the page to finish rendering (ms) */
export const FRAGMENT_SCROLL_DELAY_MS = 1_000;

// ---------------------------------------------------------------------------
// Swap widget
// ---------------------------------------------------------------------------

/** Delay between input signal change and swap state reset (ms) */
export const SWAP_INPUT_CHANGE_DELAY_MS = 600;

/** Debounce time for swap amount user input (ms) */
export const SWAP_INPUT_DEBOUNCE_MS = 500;

/** Trailing debounce after max() calculation before triggering swap update (ms) */
export const SWAP_MAX_TRAILING_DEBOUNCE_MS = 200;
